import { configureStore, combineReducers } from "@reduxjs/toolkit";
import user from "./reducers/user";
import modal from "./reducers/modal";
import storage from 'redux-persist/lib/storage'
import { persistStore, persistReducer } from 'redux-persist'
import product from "./reducers/products";
import cart from "./reducers/cart";
const allReducers = combineReducers({
    user,
    product,
    cart,
    modal,
})
const persistConfig = {
    key: 'ERC-Client',
    storage,
    blacklist: ['modal'],
}
const persistedReducer = persistReducer(persistConfig, allReducers)
export const store = configureStore({
    reducer: persistedReducer,
});
export const persistor = persistStore(store);